// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"ED-z","smallCardRow":"FD-z","largeCardRow":"GD-z","productSearchRow":"HD-z","curatedRow":"ID-z"};